import { render } from "./ResourcesGoal4c.vue?vue&type=template&id=3cb55ae4"
import script from "./ResourcesGoal4c.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal4c.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__